import type { EquippedCosmetic } from '../api/types';

export interface EquippedCosmeticVisuals {
  appearanceAssetId: string | null;
}

const PLAYER_SKIN_ID_RE = /^player_skin_[a-z0-9_]+_01$/;

export function isPlayerSkinAssetId(value: unknown): value is string {
  return typeof value === 'string' && PLAYER_SKIN_ID_RE.test(value);
}

export function appearanceAssetIdForCosmetics(cosmetics: readonly EquippedCosmetic[] | null | undefined): string | null {
  if (!cosmetics) return null;
  const skin = cosmetics.find((cosmetic) => cosmetic.kind === 'skin' || cosmetic.slot === 'skin');
  if (!skin || !skin.metadata || typeof skin.metadata !== 'object') return null;
  const assetId = (skin.metadata as { appearanceAssetId?: unknown }).appearanceAssetId;
  return isPlayerSkinAssetId(assetId) ? assetId : null;
}

export function playerSkinSpriteUrl(assetId: string | null | undefined): string | null {
  if (!isPlayerSkinAssetId(assetId)) return null;
  return `/assets/sprites/player/skins/${assetId}.png`;
}

export function playerSkinMetaUrl(assetId: string | null | undefined): string | null {
  if (!isPlayerSkinAssetId(assetId)) return null;
  return `/assets/sprites/player/skins/${assetId}.anim.json`;
}

export function getEquippedCosmeticVisuals(cosmetics: readonly EquippedCosmetic[] | null | undefined): EquippedCosmeticVisuals {
  return { appearanceAssetId: appearanceAssetIdForCosmetics(cosmetics) };
}
